<template>
  <div>
    <h1>Lista de Files</h1>
    <TableList />
  </div>
</template>

<script>
import TableList from "../Components/TableList.vue";

export default {
  components: { TableList },
};
</script>

<style></style>
